<template>
  <div>
    <b-table
      striped
      hover
      :busy="isBusy"
      :items="items"
      :fields="fields"
      class="table-main table-custom mb-0"
      show-empty
      empty-text="No matching records found"
    >
      <template v-slot:cell(note)="{ item }">
        <InputText
          v-model="item.note"
          :disabled="id > 0"
          placeholder="Note"
        ></InputText>
      </template>
      <template v-slot:cell(price)="data">
        <InputText
          placeholder="Price"
          :value="data.item.formatPrice"
          :disabled="id > 0"
          @onKeypress="handleKeyPress"
          decimalPoint="2"
          @input="(val, e) => formatPrice(val, e, data.item)"
          type="text"
          :maxLength="10"
        ></InputText>
      </template>
      <template v-slot:cell(cost)="data">
        <InputText
          placeholder="Cost"
          :disabled="id > 0"
          :value="data.item.formatCost"
          @onKeypress="handleKeyPress"
          decimalPoint="2"
          @input="(val, e) => formatCost(val, e, data.item, index)"
          type="text"
          :maxLength="10"
        ></InputText>
      </template>
      <!-- <template v-slot:foot()="data">
        <div v-if="data.field.key == 'action'" class="text-center">
          {{ totalPrice | numeral("0,0.00") }}</div
        >
        <div v-else>
          <div class="text-left px-2" v-if="data.field.key == 'name'">
            Total Price
          </div>
        </div>
      </template> -->
      <template v-slot:cell(action)="{ item, index }">
        <font-awesome-icon
          v-if="id < 1"
          icon="trash-alt"
          title="delete-btn"
          size="lg"
          class="pointer text-primary icon-delete"
          @click="deleteItem(index)"
        />
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: {
    items: { type: Array, default: [] },
  },
  data() {
    return {
      id: this.$route.params.id,
      fields: [
        { label: "Name", key: "name", thStyle: { width: "250px" } },
        { label: "Note", key: "note", thStyle: { width: "250px" } },
        { label: "ราคา", key: "price", thStyle: { width: "250px" } },
        { label: "ต้นทุนการซ่อม", key: "cost", thStyle: { width: "250px" } },

        { label: "", key: "action", thStyle: { width: "150px" } },
      ],
      isBusy: false,
    };
  },
  computed: {
    totalPrice() {
      return this.items
        .reduce((sum, item) => sum + parseFloat(item.price || 0), 0)
        .toFixed(2);
    },
  },
  methods: {
    handleKeyPress(event) {
      const char = event.key;
      const value = event.target.value;
      const cursorPos = event.target.selectionStart;

      if (!/[\d.,]/.test(char)) {
        event.preventDefault();
      }
      if (
        (char === "." && value.includes(".")) ||
        (char === "," && value.includes(","))
      ) {
        event.preventDefault();
      }

      const decimalIndex = value.indexOf(".");
      if (decimalIndex !== -1) {
        const decimalPlaces = value.length - decimalIndex - 1;
        if (decimalPlaces >= 2 && cursorPos > decimalIndex) {
          event.preventDefault();
        }
      }
    },
    formatNum(value) {
      let formatVal = Number(value).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });

      if (!formatVal.includes(".") && value) {
        formatVal = formatVal + ".00";
      }
      return formatVal;
    },
    formatPrice(val, e, item) {
      let value = val.replace(/[^0-9.]/g, "");
      const input = e.target;
      const cursorPos = input.selectionStart;
      const oldLength = input.value.length;
      if (!value || value == ".") {
        item.price = value;
        item.formatPrice = value;
        return;
      }

      let numericValue = parseFloat(value);
      if ((value.match(/\./g) || []).length > 1) {
        value = value.substring(0, value.lastIndexOf("."));
      }

      const formattedValue = Number(value).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
      item.price = numericValue;
      item.formatPrice = formattedValue;
      this.$nextTick(() => {
        const newLength = input.value.length;
        const lengthDiff = newLength - oldLength;
        const newCursorPos = cursorPos + lengthDiff;
        input.setSelectionRange(newCursorPos, newCursorPos);
      });
    },
    formatCost(val, e, item) {
      let value = val.replace(/[^0-9.]/g, "");
      const input = e.target;
      const cursorPos = input.selectionStart;
      const oldLength = input.value.length;
      if (!value || value == ".") {
        item.cost = value;
        item.formatCost = value;
        this.items.return;
      }

      let numericValue = parseFloat(value);
      if ((value.match(/\./g) || []).length > 1) {
        value = value.substring(0, value.lastIndexOf("."));
      }

      const formattedValue = Number(value).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
      item.cost = numericValue;
      item.formatCost = formattedValue;
      this.$nextTick(() => {
        const newLength = input.value.length;
        const lengthDiff = newLength - oldLength;
        const newCursorPos = cursorPos + lengthDiff;
        input.setSelectionRange(newCursorPos, newCursorPos);
      });
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
  },
};
</script>
<style scoped>
.minwidth-total {
  /* min-width:150px */
}
</style>
